export enum AUTH {
  LOGIN = "@@login",
  INIT_LOGIN = "@@init_login",
  AUTH_ERROR = "@@error_auth_occured",
  AUTH_SUCCESS = "@@success_auth",
  LOGOUT = "@@logout",
}
